export class ItemAccount {
  itemAccountId!: number;
  salesReporting!:string;
  parentAccount!:string;
  subRegion!:string;
  partnerType!:string;
  ahd_Id!:number;
  accountName!: string;
  countryName!: string;
  countryId!: number;
  regionName!: string;
  regionId!: number;
  accountTypeName!: string;
  accountTypeId!: number;
  channelId!: number;
  casepackQuant!: string;
  palletQuan!: string;
  editPermission!: any;
  constructor(itemAccount?: ItemAccount) {
    if (itemAccount) {
      this.itemAccountId = itemAccount.itemAccountId || 0;
      this.ahd_Id = itemAccount.ahd_Id || 0;
      this.accountName = itemAccount.accountName || '';
      this.countryName = itemAccount.countryName || '';
      this.countryId = itemAccount.countryId || 0;
      this.regionName = itemAccount.regionName || '';
      this.salesReporting = itemAccount.salesReporting || '';
      this.parentAccount = itemAccount.parentAccount || '';
      this.subRegion = itemAccount.subRegion || '';
      this.partnerType = itemAccount.partnerType || '';
      this.regionId = itemAccount.regionId || 0;
      this.channelId = itemAccount.channelId || 0;
      this.accountTypeName = itemAccount.accountTypeName || '';
      this.accountTypeId = itemAccount.accountTypeId || 0;
    } else {
      this.itemAccountId = 0;
      this.ahd_Id= 0;
      this.accountName = '';
      this.countryName = '';
      this.countryId = 0;
      this.channelId = 0;
      this.regionName = '';
      this.salesReporting = '';
      this.parentAccount = '';
      this.subRegion = '';
      this.partnerType = '';
      this.regionId = 0;
      this.accountTypeName = '';
      this.accountTypeId = 0;
    }
  }
}
